export default class YandexMetrikaLoader {
  constructor(windowObject, documentObject, counterId, consentVersion) {
    this.window = windowObject;
    this.document = documentObject;
    this.counterId = Number.parseInt(counterId, 10);
    this.consentVersion = consentVersion;
    this.started = false;
  }
  canStart() {
    return Number.isSafeInteger(this.counterId) && this.counterId > 9999 && this.counterId < 1_000_000_000_000 && this.analyticsAllowed();
  }
  start() {
    if (this.started || !this.canStart()) return false;
    const marker = `__devconnectYandexMetrika${this.counterId}`;

    // Серверный код мог инициализировать счётчик раньше клиентского приложения.
    // Маркер исключает повторный init и появление двух визитов при одной загрузке страницы.
    if (this.window[marker]) {
      this.started = true;
      return false;
    }
    this.started = true;
    this.window[marker] = true;
    this.window.dataLayer = this.window.dataLayer || [];
    const methodName = 'ym';
    const source = `https://mc.yandex.ru/metrika/tag.js?id=${this.counterId}`;
    this.window[methodName] = this.window[methodName] || function () {
      (this.window[methodName].a = this.window[methodName].a || []).push(arguments);
    }.bind(this);
    this.window[methodName].l = Date.now();

    // Повторяем актуальный загрузчик, который Яндекс формирует для конкретного счётчика.
    if (![...this.document.scripts].some(existing => existing.src === source)) {
      const script = this.document.createElement('script');
      script.async = true;
      script.src = source;
      script.dataset.devconnectMetrika = String(this.counterId);
      this.document.head.appendChild(script);
    }
    this.window[methodName](this.counterId, 'init', {
      ssr: true,
      webvisor: true,
      clickmap: true,
      ecommerce: 'dataLayer',
      referrer: this.document.referrer,
      url: this.window.location.href,
      accurateTrackBounce: true,
      trackLinks: true
    });
    return true;
  }
  analyticsAllowed() {
    const prefix = 'devconnect_cookie_consent=';
    const encoded = this.document.cookie.split(';').map(part => part.trim()).find(part => part.startsWith(prefix));
    if (!encoded) return false;
    const value = decodeURIComponent(encoded.slice(prefix.length));
    return value === `${this.consentVersion}:analytics`;
  }
}
flarum.reg.add('devconnect-seo', 'forum/service/YandexMetrikaLoader', YandexMetrikaLoader);